module.exports = __webpack_public_path__ + "img/pax.c1ff6f98.png";